import React from 'react';
import {
    SOCIAL_PLATFORM_DETAILS,
    renderUserToSocialPlatform,
} from '@eventbrite/collection-carousel';
import './pageHeader.scss';
import { Typography } from '@eventbrite/marmalade';
import { track } from '@eventbrite/datalayer-library';
import styles from './InfluencerDetails.module.scss';

export const InfluencerDetails = (props) => {
    const { id, name, social } = props.influencerData;

    const handleSocialOnClick = (social_platform) => {
        renderUserToSocialPlatform(social_platform);
        track({
            eventName: 'InfluencerCollectionSocialAnchor',
            eventData: {
                influencerHandle: social_platform.handle,
                socialAnchor: social_platform.platform,
            },
        });
    };

    return (
        <>
            <Typography variant="heading-lg" className={styles.influencer_name}>
                {name}
            </Typography>
            <div className={styles.social_handles}>
                {social.map((social_platform) => (
                    <div
                        data-heap-id="influencer-collection-social-anchor"
                        onClick={() => handleSocialOnClick(social_platform)}
                        key={social_platform.platform}
                        className={styles.social_platform}
                    >
                        <img
                            alt={social_platform.platform}
                            src={
                                SOCIAL_PLATFORM_DETAILS[
                                    social_platform.platform
                                ].icon
                            }
                        />
                        <Typography variant="body-sm">
                            @{social_platform.handle}
                        </Typography>
                    </div>
                ))}
            </div>
        </>
    );
};
